import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { CnpjService } from "src/app/core/services/cnpj-service";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { InitProvider } from "src/app/core/services/init-provider";
import { PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { IeService } from "src/app/core/services/ie-service";
import Swal from "sweetalert2";
import { Observable } from "rxjs";
import { validaCPF } from "src/app/core/validators/cpf.validator";
import { validaCNPJ } from "src/app/core/validators/cnpj.validators";
import { ConfiguracoesForm } from "src/app/core/entities/configuracoesForms";
declare var $: any;

@Component({
  selector: "novo-cliente",
  templateUrl: "./novo-cliente.component.html",
  styleUrls: ["./novo-cliente.component.css"],
})
export class NovoClienteComponent implements OnInit {
  SITE: ConfiguracoesSite;
  public nomeLabel1 = "Razão Social";
  public backgroundColor: string;
  public representante = "";
  public lgpdAccepted = false
  public nomeLabel2 = "Fantasia";
  public documentMask = "AA.AAA.AAA/AAAA-00";
  noResult = false;
  representantes: Observable<any[]>;
  public documentLabel1 = "CNPJ";
  public documentLabel2 = "IE";
  public statusCNPJ = "";
  public mensagemStatusCNPJ = "";
  public isOpen: boolean = false;
  public error: Boolean = false;
  public lgpd: String = '';
  public validaCadastro: boolean = true;
  typingRepresentante: string = "";
  public errorMsg: String;
  public form: FormGroup;
  public tipoCliente: any[] = [
    {
      title: "Atacado",
      value: "atacado",
      class: "tipo-cliente-atacado",
    },
    {
      title: "Franquia",
      value: "franquia",
      class: "tipo-cliente-franquia",
    },
  ];
  public ufs: string[] = [
    "AC",
    "AL",
    "AM",
    "AP",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MG",
    "MS",
    "MT",
    "PA",
    "PB",
    "PE",
    "PI",
    "PR",
    "RJ",
    "RN",
    "RO",
    "RR",
    "RS",
    "SC",
    "SE",
    "SP",
    "TO",
  ];
  public cities: [] = [];
  public tipo_empresa = [
    { id: 1, label: "EMPRESA NORMAL" },
    { id: 2, label: "EPP - PEQUENO PORTE" },
    { id: 3, label: "EPP SIMPLES" },
    { id: 4, label: "ME - MICRO EMPRESA" },
    { id: 0, label: "CONSUMIDOR FINAL" },
  ];
  public tipo_empresaPF = [{ id: 0, label: "CONSUMIDOR FINAL" }];
  public tipo_empresaPJ = [
    { id: 1, label: "EMPRESA NORMAL" },
    { id: 2, label: "EPP - PEQUENO PORTE" },
    { id: 3, label: "EPP SIMPLES" },
    { id: 4, label: "ME - MICRO EMPRESA" },
  ];

  public tableInfoDoc;
  public cnpjHistory;

  public isentoIE: boolean = false;
  limiteCaracteresEndereco: any = 43;

  @Input() registro: boolean = false;
  @Input() cadastroCliente: boolean;
  @Input() edit: boolean = false;
  @Input() selectedClient: any = {};
  @Input() cadastros: boolean = false;
  @Input() lgpdCheck: boolean = false
  @Input() layoutB2c: boolean = false
  @Output() page = new EventEmitter<number>();

  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    public usuarioService: UsuarioService,
    private initProvider: InitProvider,
    public ieService: IeService,
    private cnpjService: CnpjService,
    public toastService: ToastrService,
    private router: Router
  ) {
    if (isPlatformBrowser(this.platformId)) {
      $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }
    this.SITE = Configuracoes.SITE;
    this.validaCadastro = Configuracoes.validaCadastro;
    // this.backgroundColor = Configuracoes.SITE.backgroundColorSliderSuperior;
    this.form = this.formBuilder.group({
      nome1: ["", [Validators.required]],
      nome2: [""],
      email: [
        "",
        this.validaCadastro ? [Validators.required, Validators.email] : [],
      ],
      emailContato: [""],
      tipo_empresa: ["", this.validaCadastro ? [Validators.required] : []],
      tipo: [
        this.SITE.tipo_documento_liberado
          ? this.SITE.tipo_documento_liberado.toUpperCase()
          : "CNPJ",
        this.validaCadastro ? [Validators.required] : [],
      ],
      numDocumento1: [
        "",
        this.validaCadastro ? [Validators.required, validaCNPJ] : [],
      ],
      numDocumento2: [
        "",
        this.validaCadastro && !this.isentoIE && this.documentLabel2 === 'CNPJ' ? [Validators.required] : [],
      ],
      // endereço
      endereco: ["", [Validators.required]],
      numero: ["", [Validators.required]],
      cep: ["", [Validators.required]],
      bairro: ["", [Validators.required]],
      uf: ["", [Validators.required]],
      cidade: ["", [Validators.required]],
      contato: [""],
      cliente_ecommerce: [false, [Validators.required]],
      complemento: [""],
      dddWhatsapp: ["", [Validators.required]],
      telefoneWhatsapp: [
        "", [
          Validators.required,
          Validators.minLength(10),
          Validators.pattern(/^9\d{4}-\d{4}$/),
        ],
      ],
      ddd: ["", []],
      telefone: [
        "",
        [
          Validators.minLength(9),
          Validators.pattern(/^[2-5]\d{3}-?\d{4}$/)
        ],
      ],
      observacao: [""],
      instagram: [""],
      tiktok: [""],
      twitter: [""],
      facebook: [""],
      midiaSocial: [""],
      suframa: [""],
      tipo_cliente: [
        "atacado",
        this.validaCadastro ? [Validators.required] : [],
      ],
    });
    this.formatDocument(
      this.SITE.tipo_documento_liberado
        ? this.SITE.tipo_documento_liberado.toUpperCase()
        : "CNPJ"
    );
    this.representantes = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.listaRepresentante(
          {
            nome: this.typingRepresentante,
            documento: "",
            status: "",
            page: 0,
          },
          function (resp) {
            const primeirosDez = resp.slice(0, 10);
            observer.next(primeirosDez);
          }.bind(this),
          this.callbackError.bind(this)
        );
      }
    });
    this.limiteCaracteresEndereco= ConfiguracoesForm.cadastroCliente.endereco.limiteCaracteres ?? 43 
  }
  callbackErrorRep(resp) {
    Swal.fire(
      $localize`Representante`,
      $localize`Algo deu errado. Tente novamente mais tarde`,
      "warning"
    );
  }
  openModal() {
    this.isOpen = true;
  }
  closeModal() {
    this.isOpen = false;
  }
  formatDoc(document: string): string {
    // Remover todos os caracteres não numéricos
    const cleanedDocument = document.replace(/\D/g, "");

    let formattedDocument: string;

    if (cleanedDocument.length === 14) {
      // Formatar como CNPJ
      formattedDocument = cleanedDocument.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    } else if (cleanedDocument.length === 11) {
      // Formatar como CPF
      formattedDocument = cleanedDocument.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        "$1.$2.$3-$4"
      );
    } else {
      throw new Error(
        "O documento deve ter 11 dígitos (CPF) ou 14 dígitos (CNPJ)."
      );
    }

    return formattedDocument;
  }
  onSelect(event) {
    this.representante = event.item.id;
  }

  atualizaValidacaoNumDocumento() {
    const control = this.form.get("numDocumento2");

    if (!this.isentoIE) {
      control?.setValidators(this.validaCadastro && this.documentLabel2 === 'CNPJ' ? [Validators.required] : []);
    } else {
      control?.setValue("");
      control?.clearValidators();
    }

    control?.updateValueAndValidity();
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  formatToPhone(input: string): string {
    // Remover todos os caracteres não numéricos
    const cleanedInput = input.replace(/\D/g, "");

    const formattedPhone =
      cleanedInput.length === 9
        ? cleanedInput.replace(/^(\d{5})(\d{4})$/, "$1-$2")
        : cleanedInput.replace(/^(\d{4})(\d{4})$/, "$1-$2");

    return formattedPhone;
  }

  consultaCnpj(event, callCnpjCancel = false) {
    if (callCnpjCancel) {
      return;
    }
    let cnpj = event;

    if (this.form.controls.tipo.value != "CNPJ") {
      return;
    }

    if (this.form.controls.numDocumento1.invalid) {
      if (cnpj.length > 12) Swal.fire("CNPJ", "CNPJ Inválido", "error");
      return;
    }

    if (cnpj == this.cnpjHistory) {
      return;
    }

    this.cnpjHistory = cnpj;
    this.cnpjService.getCnpjAPIAgilb2b(
      cnpj,
      function (resp) {
        this.form.controls.nome1.setValue(resp.razao_social);
        if (resp.nome_fantasia) {
          this.form.controls.nome2.setValue(resp.nome_fantasia);
        }
        if (resp.status) {
          this.statusCNPJ = resp.status;
        }
        if (resp.mensagem_status) {
          this.mensagemStatusCNPJ = resp.mensagem_status;
        }
        this.form.controls.nome1.setValue(resp.razao_social);
        if (resp.tipo_cliente) {
          this.form.controls.tipo_cliente.setValue(resp.tipo_cliente);
        }
        // if (resp.email) {
        //     this.form.controls.email.setValue(resp.email);
        // }
        if (resp.endereco && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.endereco.setValue(resp.endereco);
        }
        if (resp.bairro && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.bairro.setValue(resp.bairro);
        }
        if (resp.numero && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.numero.setValue(resp.numero_ed);
        }
        if (resp.cep && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.cep.setValue(resp.cep.replace(".", ""));
        }
        if (resp.complemento && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.complemento.setValue(resp.complemento);
        }
        if (resp.ie && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.numDocumento2.setValue(resp.ie);
        }
        if (resp.email && !Configuracoes.MISC.miscCadCliNoAutEndereco) {
          this.form.controls.email.setValue(resp.email);
        }
        if (resp.estado && resp.cidade) {
          this.form.controls.uf.setValue(resp.estado);
          this.searchCities(resp.cidade);
        }
        let situacao = "-";
        let tipo = "-";
        let atividadePrincipal = "-";
        let naturezaJuridica = "-";
        let telefone = "-";
        let atualizacao = resp.ultima_atualizacao
          ? resp.ultima_atualizacao.substr(0, 10)
          : "";
        if (resp.situacao) {
          situacao = resp.situacao;
        }
        if (resp.motivo_situacao) {
          situacao += " - " + resp.motivo_situacao;
        }
        if (resp.data_situacao) {
          situacao += " - " + resp.data_situacao;
        }
        if (resp.tipo) {
          tipo = resp.tipo;
        }
        if (resp.atividade_principal && resp.atividade_principal[0]) {
          atividadePrincipal =
            resp.atividade_principal[0].code +
            " - " +
            resp.atividade_principal[0].text;
        }
        if (resp.natureza_juridica) {
          naturezaJuridica = resp.natureza_juridica;
        }
        if (resp.telefone) {
          telefone = resp.telefone;
        }
        let str = `<thead><tr><th colspan="2" scope="col">${cnpj}</th></tr></thead>
            <tr><td>Situação</td><td>${situacao}</td></tr>
            <tr><td>Tipo</td><td>${tipo}</td></tr>
            <tr><td>Atividade Principal</td><td>${atividadePrincipal}</td></tr>
            <tr><td>Natureza Jurídica</td><td>${naturezaJuridica}</td></tr>
            <tr><td>Telefone</td><td>${telefone}</td></tr>
            <tr><td>Atualização</td><td>${atualizacao}</td></tr>`;
        this.tableInfoDoc = str;
      }.bind(this)
    );
  }

  getCepValue(cep) {
    this.form.controls.endereco.setValue("Rua Silva Paulet");
    this.form.controls.bairro.setValue("Meireles");
    this.form.controls.uf.setValue("CE");
    this.searchCities("Fortaleza");
    // this.form.controls.cidade.setValue("Fortaleza")
    if (cep.length < 8) {
      return;
    }
    this.usuarioService.getCep(
      cep,
      function (resp) {
        this.form.controls.endereco.setValue(resp.logradouro);
        this.form.controls.endereco.setValue(resp.bairro);
        this.form.controls.uf.setValue(resp.uf);
        this.form.controls.cidade.setValue(resp.localidade);
      },
      function (resp) {
        this.form.controls.endereco.value = "Rua Silva Paulet";
        this.form.controls.bairro.value = "Meireles";
        this.form.controls.uf.value = "CE";
        this.form.controls.cidade.value = "Fortaleza";
      }
    );
  }

  onSubmit() {
    let data: any = this.form.value;

    this.error = false;
    // if (!this.cadastros) {
    //   this.form.controls.tipo_cliente.setValue("franquia");
    // }
    if (!this.form.valid) {
      this.error = true;
      this.errorMsg = "Confira o formulário corretamente!";
      return;
    }

    for (const chave in data) {
      if (data.hasOwnProperty(chave)) {
        if (data[chave] === "") {
          data[chave] = null;
        }
      }
    }

    if (this.statusCNPJ !== "" && this.statusCNPJ !== "Ativa") {
      this.toastService.warning(
        this.mensagemStatusCNPJ,
        $localize`Situação cadastral: ${this.statusCNPJ}`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    if (
      !this.isentoIE &&
      !this.ieService.validar(
        this.form.value.numDocumento2,
        this.form.value.uf
      ) &&
      this.form.value.tipo === "CNPJ" &&
      this.validaCadastro
    ) {
      this.toastService.warning(
        $localize`Inscrição estadual inválida!`,
        $localize`Cliente`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      return;
    }
    // Transformar os campos de redes sociais em array de objetos
    const redes = ["instagram", "tiktok", "twitter", "facebook", "youtube"];
    const midias = redes
      .filter((rede) => data[rede])
      .map((rede) => ({
        rede_social: rede.toUpperCase(),
        link: data[rede],
      }));

    // Criar novo objeto no formato desejado
    const resultado = {
      ...data,
      midias,
    };
    if (!this.usuarioService.loading) {
      if (!this.cadastros && !this.layoutB2c) {
        this.usuarioService.cadastraCliente(
          this.registro,
          // data,
          { ...resultado, representante: this.representante },
          this.callback.bind(this),
          this.callbackError.bind(this)
        );
      } else {
        this.usuarioService.cadastraClienteInterno(
          // data,
          {
            ...resultado,
            representante:
              this.typingRepresentante === "" ? null : this.representante,
          },
          this.callback.bind(this),
          this.callbackError.bind(this)
        );
      }
    }
  }

  callback(resp) {
    // if (resp.cliente && resp.cliente == "ok") {
    this.page.emit(1);
    if (this.registro) {
      Swal.fire(
        $localize`Registro`,
        this.SITE.menssagemAposCadastro
          ? this.SITE.menssagemAposCadastro
          : $localize`Cadastro realizado com sucesso! Para garantir sua segurança, enviamos um e-mail de confirmação. Acesse sua caixa de entrada e siga as instruções para concluir o cadastro.`,
        "success"
      );
      if (isPlatformBrowser(this.platformId)) {
        $("#cadastraModal").modal("hide");
      }
      if (!this.layoutB2c) {
        this.router.navigate(["login"]);
      }
    } else {
      Swal.fire(
        $localize`Cliente`,
        this.SITE.menssagemAposCadastro
          ? this.SITE.menssagemAposCadastro
          : $localize`Cadastrado com sucesso!`,
        "success"
      );
      if (!this.edit && !this.cadastros) {
        this.router.navigate(["novo-pedido"]);
      }
    }
    // }
  }

  sanitizeInput(event: any) {
    const inputValue: string = event.target.value;
    const sanitizedValue = this.sanitizeString(inputValue);
    this.form.controls.observacao.setValue(sanitizedValue);
  }

  sanitizeString(input: string): string {
    // Remove aspas simples e duplas
    const sanitizedInput = input.replace(/['"]/g, "");
    return sanitizedInput;
  }

  callbackError(error) {
    if (error.status === 400) {
      this.toastService.warning(error.error.detail, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
    } else if (error.status === 403) {
      this.toastService.warning(
        $localize`Usuario não autenticado`,
        $localize`Cliente`,
        {
          positionClass: "toast-bottom-left",
        }
      );
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
    } else if (error.status === 500) {
      this.toastService.warning(
        $localize`Algo deu errado`,
        $localize`Cliente`,
        {
          positionClass: "toast-bottom-left",
        }
      );
    }
  }
  formatDocument(v) {
    let value = v;
    if (value == "CPF") {
      this.tipo_empresa = this.tipo_empresaPF;
      this.form.controls.tipo_empresa.setValue(0);
      this.documentMask = "000.000.000-00";
      this.form.controls.numDocumento1.setValidators(
        this.validaCadastro ? [Validators.required, validaCPF] : []
      );
      this.form.controls.numDocumento2.setValidators([]);
      this.documentLabel1 = "CPF";
      this.documentLabel2 = "RG";
      this.nomeLabel1 = "Nome";
      this.nomeLabel2 = "";
      this.form.controls.nome2.clearValidators();
    } else {
      this.tipo_empresa = this.tipo_empresaPJ;
      // this.form.controls.tipo_empresa.setValue(0);
      this.documentMask = "AA.AAA.AAA/AAAA-00";
      this.form.controls.numDocumento1.setValidators(
        this.validaCadastro ? [Validators.required, validaCNPJ] : []
      );
      this.form.controls.numDocumento2.setValidators(
        this.validaCadastro && !this.isentoIE && this.documentLabel2 === 'CNPJ' ? [Validators.required] : []
      );
      this.documentLabel1 = "CNPJ";
      this.documentLabel2 = "IE";
      this.nomeLabel1 = "Razão Social";
      this.nomeLabel2 = "Fantasia";
      this.form.controls.nome2.setValidators(
        this.validaCadastro ? [Validators.required] : []
      );
    }
    this.form.controls.nome2.updateValueAndValidity();
    this.form.controls.numDocumento2.updateValueAndValidity();
    // this.form.controls.numDocumento1.reset();
  }

  searchCities(cidade: string = null) {
    let uf = this.form.value.uf;
    this.usuarioService.cidadesPorUf(
      uf,
      function (resp) {
        this.cities = resp;
        this.cities.forEach((c) => {
          c.nome = c.nome.toLocaleUpperCase();
        });
        if (cidade) {
          //this.form.controls.cidade.setValue(cidade);
          setTimeout(
            function () {
              let city = this.cities.filter(
                (c) => c.nome === cidade.toUpperCase()
              );
              this.form.controls.cidade.setValue(city[0].id);
            }.bind(this),
            1000
          );
        }
      }.bind(this)
    );
  }

  ngOnInit() {
    if (Configuracoes.tipoCliente) {
      this.tipoCliente = Configuracoes.tipoCliente;
    }

    if (Configuracoes.SITE?.lgpd) {
      this.lgpd = Configuracoes.SITE.lgpd;
    }

    if (Configuracoes.SITE?.backgroundColorSliderSuperior) {
      this.backgroundColor = Configuracoes.SITE.backgroundColorSliderSuperior;
    }

    if (this.edit && this.selectedClient) {

      const client = this.selectedClient;

      const endereco = client.enderecos?.length
        ? client.enderecos[0]
        : {
          endereco: client.endereco,
          bairro: client.bairro,
          cep: client.cep,
          uf: client.uf,
          numero: client.numero,
          complemento: client.complemento,
          cidade: client.nomecidade
        };

      const documento = client.cnpj ? client.cnpj : client.numdocumento;
      const isCpf = documento?.length <= 14;

      this.documentMask = isCpf
        ? "000.000.000-00"
        :"AA.AAA.AAA/AAAA-00";

      this.form.controls.tipo.setValue(isCpf ? "CPF" : "CNPJ");
      this.isentoIE = this.edit && (client.numdocumento1 === "" || client.numdocumento1 === null)
      // console.log(this.edit)
      // console.log(client.numdocumento1)
      this.form.controls.numDocumento1.setValue(this.formatDoc(documento));
      this.form.controls.numDocumento2.setValue(client.numdocumento1 ?? "");

      this.form.controls.nome1.setValue(client.nome);
      this.form.controls.nome2.setValue(client.fantasia);

      this.form.controls.email.setValue(client.email);
      this.form.controls.emailContato.setValue(client.email_contato);

      this.form.controls.tipo_empresa.setValue(client.tipoempresa);
      this.form.controls.tipo_cliente.setValue(client.tipo_cliente);

      this.form.controls.dddWhatsapp.setValue(
        client.dddwhatsapp ?? ""
      );
      
      this.form.controls.cliente_ecommerce.setValue(
        client.cliente_ecommerce ?? ""
      );

      this.form.controls.telefoneWhatsapp.setValue(
        client.telefonewhatsapp
          ? this.formatToPhone(client.telefonewhatsapp)
          : ""
      );

      this.form.controls.ddd.setValue(client.ddd ?? "");

      this.form.controls.telefone.setValue(
        client.telefone
          ? this.formatToPhone(client.telefone)
          : ""
      );

      if (endereco) {
        this.form.controls.endereco.setValue(endereco.endereco);
        this.form.controls.numero.setValue(endereco.numero);
        this.form.controls.bairro.setValue(endereco.bairro);
        this.form.controls.cep.setValue(endereco.cep);
        this.form.controls.uf.setValue(endereco.uf);
        this.form.controls.complemento.setValue(endereco.complemento);

        this.form.controls.cidade.setValue(client.cidade);

        this.searchCities(client.cidades?.nome ?? client.nomecidade);
      }

      this.form.controls.contato.setValue(client.contato);
      this.form.controls.observacao.setValue(client.observacao);
      this.form.controls.suframa.setValue(client.suframa);

      this.form.controls.instagram.setValue(client.instagram ?? "");
      this.form.controls.tiktok.setValue(client.tiktok ?? "");
      this.form.controls.twitter.setValue(client.twitter ?? "");
      this.form.controls.facebook.setValue(client.facebook ?? "");
      this.form.controls.midiaSocial.setValue(client.midiaSocial ?? "");

      this.typingRepresentante = client.nome_representante;
      this.representante = client.representante;

      this.typingRepresentante = client.nome_representante;
      this.representante = client.representante;

      this.atualizaValidacaoNumDocumento();
    }

    this.formatDocument(
      this.selectedClient?.tipodocumento ??
      this.SITE?.tipo_documento_liberado?.toUpperCase() ??
      "CNPJ"
    );
  }
}
